import type { NovelImportPreviewInput } from '@/api/novelImportApi'

function hashString(value: string) {
  let hash = 2166136261
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return hash >>> 0
}

export function novelImportPreviewKey(body: NovelImportPreviewInput) {
  const regex = body.custom_regex ?? ''
  const format = body.format ?? ''
  return [
    body.text.length,
    hashString(body.text),
    regex.length,
    hashString(regex),
    Boolean(body.allow_markdown_heading) ? 1 : 0,
    format,
  ].join(':')
}

export function isNovelImportPreviewCurrent(previewKey: string, currentBody: NovelImportPreviewInput) {
  return previewKey === novelImportPreviewKey(currentBody)
}
